import { initializeApp } from 'firebase/app';
import {
  getAuth,
  isSignInWithEmailLink as firebaseIsSignInWithEmailLink,
  signInWithCustomToken,
  signInWithEmailAndPassword,
  signInWithEmailLink as firebaseSignInWithEmailLink,
  signOut,
  updatePassword as firebaseUpdatePassword,
} from 'firebase/auth';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  dev: {
    apiKey: 'AIzaSyALJVgeWBWXgjHg9z5N-njc1D_psDcuRiQ',
    authDomain: 'relance-comm-dev.firebaseapp.com',
    projectId: 'relance-comm-dev',
    storageBucket: 'relance-comm-dev.appspot.com',
    messagingSenderId: '655475897117',
    appId: '1:655475897117:web:21f23538ea8448e32b67f4',
    tenantId: 'enterprise-uga8f',
  },
  stg: {
    apiKey: 'AIzaSyC0wugxYu_y-zmAasmpcepf9V441rrJV0w',
    authDomain: 'relance-comm-stg.firebaseapp.com',
    projectId: 'relance-comm-stg',
    storageBucket: 'relance-comm-stg.appspot.com',
    messagingSenderId: '325244328271',
    appId: '1:325244328271:web:815f6fee097a4b1f000d3a',
    tenantId: 'enterprise-f8egr',
  },
  prd: {
    apiKey: 'AIzaSyCKuhTwazl4v3kRoS9JeH3QQpRlHUz1XmY',
    authDomain: 'relance-comm-prd.firebaseapp.com',
    projectId: 'relance-comm-prd',
    storageBucket: 'relance-comm-prd.appspot.com',
    messagingSenderId: '949990111252',
    appId: '1:949990111252:web:8a85025e10e7bf4fa1cf01',
    tenantId: 'enterprise-s71vt',
  },
};


let firebaseInitialized = false;

// Initialize Firebase
export const initFirebase = (env: string) => {
  // Prevent re-initialization
  if (firebaseInitialized) return;

  const mode = (env as 'dev' | 'stg' | 'prd') || 'dev';
  const config = firebaseConfig[mode];

  if (!config) {
    console.warn(`Firebase config not found for environment: ${env}, using 'dev'`);
    const app = initializeApp(firebaseConfig.dev);
    const auth = getAuth(app);
    auth.tenantId = firebaseConfig.dev.tenantId;
  } else {
    const app = initializeApp(config);
    const auth = getAuth(app);
    auth.tenantId = config.tenantId;
  }

  firebaseInitialized = true;
}

export const authClient = () => {
  const auth = getAuth();
  return auth;
};

export const destroyBrowserSessionCookie = async () => {
  const formData = new FormData();
  formData.append('intent', 'logout');

  const response = await fetch('/api/auth/session', {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    throw new Error('Failed to destroy session cookie');
  }
};

export const logout = async () => {
  await destroyBrowserSessionCookie();
  await signOut(authClient());
};

export const signInWithFirebaseCustomToken = async (token: string) => {
  return signInWithCustomToken(authClient(), token);
};

export const signInWithFirebaseEmailAndPassword = async (email: string, password: string) => {
  return signInWithEmailAndPassword(authClient(), email, password);
};

/**
 * 現在のURLがEmail Linkによるサインインリンクかどうかを判定
 */
export const isSignInWithEmailLink = (url: string): boolean => {
  return firebaseIsSignInWithEmailLink(authClient(), url);
};

/**
 * Email Linkでサインイン（パスワードレス認証）
 * @param email メールアドレス
 * @param emailLink 招待メールのリンクURL
 */
export const signInWithEmailLink = async (email: string, emailLink: string) => {
  return firebaseSignInWithEmailLink(authClient(), email, emailLink);
};

/**
 * 現在ログイン中のユーザーのパスワードを更新
 * @param newPassword 新しいパスワード
 */
export const updatePassword = async (newPassword: string) => {
  const user = authClient().currentUser;
  if (!user) {
    throw new Error('ユーザーがログインしていません');
  }
  return firebaseUpdatePassword(user, newPassword);
};

/**
 * 現在のユーザーを取得
 */
export const getCurrentUser = () => {
  return authClient().currentUser;
};
